// src/App.js
import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { fetchPosts } from './api/strapi';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import PartnerPage from './pages/PartnerPage';
import BlogListPage from './pages/BlogListPage';
import BlogPage from './pages/BlogPage';
import AllReportsPage from './pages/AllReportsPage';
import ReportPage from './pages/ReportPage';
import ContactPage from './pages/ContactPage';
import CookieBanner from './components/CookieBanner';
import CookiesPage from './pages/CookiesPage';
import AntiTrustPage from './pages/AntiTrustPage';
import ServicesPage from './pages/ServicesPage';
import ScrollToTop from './components/ScrollToTop'; // Correct path
import NewsletterPage from './pages/NewsletterPage';
import PrivacyPage from './pages/PrivacyPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

function App() {
const [posts, setPosts] = useState(null);

useEffect(() => {
fetchPosts()
 .then(fetched => setPosts(fetched))
 .catch(err => {
 console.error("🛑 Failed to load posts", err);
 setPosts([]);
 });
 }, []);

  const appContentRef = useRef(null);

 return (
 <Router>
  <ScrollToTop scrollContainerRef={appContentRef} />
 <HelmetProvider>
   <div
          className="app-scroll-container" // New class for styling if needed
          ref={appContentRef} // Attach the ref
          style={{ overflowY: 'auto', height: '100vh', scrollBehavior: 'smooth' }} // Or define these in CSS
        >
 <Header />

 <Routes>
 <Route path="/" element={<HomePage posts={posts} />} />
<Route path="/about" element={<AboutPage />} />
<Route path="/unicon" element={<PartnerPage />} />
 <Route path="/blog" element={<BlogListPage />} />
<Route path="/blog/:slug" element={<BlogPage />} />
 <Route path="/reports" element={<AllReportsPage />} />
 <Route path="/reports/:slug" element={<ReportPage />} />
 <Route path="/contact" element={<ContactPage />} />
 <Route path="/newsletter" element={<NewsletterPage />} />
 <Route path="/antitrust" element={<AntiTrustPage />} />
 <Route path="/services" element={<ServicesPage />} />
 <Route path="/reset-password" element={<ResetPasswordPage />} />
<Route path="/cookies" element={<CookiesPage />} />
 <Route path="/privacy" element={<PrivacyPage />} />
 </Routes>
 <CookieBanner />
 </div>
 </HelmetProvider>
 </Router>
 );
}

export default App;
